<app-sub-page navBackRoute="/charts">
  <div class="flex column width-100 gap-05 flex-1" style="margin-top: -0.5rem; max-width: 800px">
    <div class="text-title width-100 flex flex-center">{{ chartTitle }}</div>
    @if (chartType != "work") {
    <div class="card width-100 column flex-center flex" style="padding: 0.5rem">
      <p-tabMenu [model]="tabItems" [activeItem]="activeItem" (activeItemChange)="onTimeframeChange($event)" />
    </div>
    }
    <div class="card width-100 column" style="padding: 0.5rem">
      <p-chart type="bar" [data]="chartData" [options]="chartOptions" width="100%" [height]="getChartHeight()" />
    </div>
  </div>
</app-sub-page>
